/**
 * Color Schemes for Municipal Portal
 * Define as paletas de cores disponíveis para o portal
 */

export interface ColorScheme {
  name: string;
  primary: string;
  secondary: string;
  accent: string;
  background: {
    default: string;
    paper: string;
  };
  text: {
    primary: string;
    secondary: string;
  };
}

export const COLOR_SCHEMES: Record<string, ColorScheme> = {
  blue: {
    name: 'Azul Institucional',
    primary: '#1976d2',
    secondary: '#0d47a1',
    accent: '#42a5f5',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  green: {
    name: 'Verde Sustentável',
    primary: '#2e7d32',
    secondary: '#1b5e20',
    accent: '#66bb6a',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  red: {
    name: 'Vermelho Executivo',
    primary: '#c62828',
    secondary: '#b71c1c',
    accent: '#e57373',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  yellow: {
    name: 'Amarelo Energia',
    primary: '#f9a825',
    secondary: '#f57f17',
    accent: '#fdd835',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  gray: {
    name: 'Cinza Corporativo',
    primary: '#546e7a',
    secondary: '#37474f',
    accent: '#78909c',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  purple: {
    name: 'Roxo Moderno',
    primary: '#6a1b9a',
    secondary: '#4a148c',
    accent: '#9c27b0',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  orange: {
    name: 'Laranja Vibrante',
    primary: '#ed6c02',
    secondary: '#e65100',
    accent: '#ff9800',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  brown: {
    name: 'Marrom Clássico',
    primary: '#5d4037',
    secondary: '#3e2723',
    accent: '#8d6e63',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
};

export type ColorSchemeType = keyof typeof COLOR_SCHEMES;

export const DEFAULT_COLOR_SCHEME: ColorSchemeType = 'blue';

/**
 * Maps the theme number from parametersPortal to a color scheme
 * @param themeNumber - The theme number from parametersPortal
 * @returns The corresponding color scheme key
 */
export const getColorSchemeByThemeNumber = (themeNumber: number | undefined): ColorSchemeType => {
  if (!themeNumber) return DEFAULT_COLOR_SCHEME;

  switch (themeNumber) {
    case 1:
    case 2:
      return 'yellow';
    case 3:
    case 4:
      return 'blue';
    case 5:
      return 'gray';
    case 6:
      return 'orange';
    case 7:
      return 'brown';
    case 8:
    case 9:
      return 'green';
    case 10:
      return 'red';
    default:
      return 'blue';
  }
};
